import React from 'react';

import { LoadingIndicator } from '@lf/ui-primitives';
import VideoList from '../../components/VideoList';
import YouTubeVideoCard from './YouTubeVideoCard';

const SavedView = ({ isLoading, videoCards, onVideoSelect, onChannelSelect, onSaveToggle }) => (
  <div className="space-y-4">
    <div className="flex items-center justify-between">
      <h2 className="text-lg font-semibold">Saved videos</h2>
    </div>
    {isLoading ? (
      <div className="mt-6">
        <LoadingIndicator />
      </div>
    ) : videoCards.length > 0 ? (
      <VideoList>
        {videoCards.map((video) => (
          <YouTubeVideoCard
            key={video.id?.videoId}
            video={video}
            onSelect={onVideoSelect}
            onChannelSelect={onChannelSelect}
            isSaved
            onSaveToggle={onSaveToggle}
          />
        ))}
      </VideoList>
    ) : (
      <div className="text-gray-500">No saved videos yet.</div>
    )}
  </div>
);

export default SavedView;
